import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { EncuestaSatisfaccionService } from 'src/app/servicios/encuesta-satisfaccion/encuesta-satisfaccion.service';

@Component({
  selector: 'app-floating-survey-indicator',
  standalone: true,
  imports: [AsyncPipe, MatBadgeModule, MatButtonModule, MatIconModule, MatTooltipModule, TranslateModule],
  templateUrl: './floating-survey-indicator.component.html',
  styleUrls: ['./floating-survey-indicator.component.scss'],
})
export class FloatingSurveyIndicatorComponent implements OnInit {
  private encuestaService = inject(EncuestaSatisfaccionService);

  /** FAB solo si Pospuesto=1 y aún sin FechaRespuesta. */
  visible$ = this.encuestaService.pending$.pipe(map((p) => !!p && p.Pospuesto && !p.FechaRespuesta));

  ngOnInit() {
    this.encuestaService.bootstrapForLoggedUser();
  }

  onClick() {
    this.encuestaService.openFormulario();
  }
}
